import * as React from "react";
function SvgIcTableColumnNumerical(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.28 20h1.298l.276-1.929h2.558L18.136 20h1.299l.276-1.929h1.646v-1.285h-1.462l.37-2.572H22V12.93h-1.554L20.72 11h-1.299l-.276 1.929h-2.558L16.864 11h-1.299l-.276 1.929h-1.646v1.285h1.462l-.37 2.572H13v1.285h1.554L14.28 20zm2.129-5.781h2.558l-.373 2.571H16.04l.37-2.571zM2 2h20v4H2V2zm1 1v2h18V3H3zM2 7h7v4H2V7zm1 1v2h5V8H3zm-1 4h7v4H2v-4zm1 1v2h5v-2H3zm-1 4h7v4H2v-4zm1 1v2h5v-2H3z"
        fill="currentColor"
      />
    </svg>
  );
}
export default SvgIcTableColumnNumerical;
